import { Box, Flex, Text, Icon } from '@chakra-ui/react';
import React from 'react';
import { MdDoubleArrow } from 'react-icons/md';

export const Lugar = ({
  front,
  distance,
  ranking,
  isFrontPrimary,
  isDistancePrimary,
  rankingValorProximo,
  isPrimaryPedido
}) => {
  if (!front || !distance || !ranking) {
    return null;
  }

  if ((isFrontPrimary && isDistancePrimary) || isPrimaryPedido) {
    return (
      <Flex flexDir="column" gap={2} fontSize="12px">
        <Flex alignItems="center" justifyContent="space-between" gap={2}>
          <Text>Você está em</Text>
          <Box px={2} bgColor="green.500" color="white">
            <strong>1º</strong> lugar
          </Box>
        </Flex>
        <Flex alignItems="center" justifyContent="space-between">
          <Text>
            e <strong>{front} </strong>a frente do
          </Text>
          <Flex alignItems="center" gap={1}>
            <Icon as={MdDoubleArrow} transform="rotate(90deg)" fontSize="20px" color="red.500" />
            <Box px={2} bgColor="red.500" color="white">
              {rankingValorProximo}º lugar
            </Box>
          </Flex>
        </Flex>
      </Flex>
    );
  }
  //se isFrontPrimary for true, então vai estar em primeiro lugar
  //se isDistancePrimary for true, então vai estar em primeiro lugar

  return (
    <Flex flexDir="column" gap={2} fontSize="12px">
      <Flex alignItems="center" justifyContent="space-between">
        <Text>
          Você está à <strong>{distance}</strong> do
        </Text>
        <Flex alignItems="center" gap={1}>
          <Icon as={MdDoubleArrow} transform="rotate(-90deg)" fontSize="20px" color="green.500" />
          <Box px={2} bgColor="green.500" color="white">
            {ranking}º lugar
          </Box>
        </Flex>
      </Flex>

      <Flex alignItems="center" justifyContent="space-between">
        <Text>
          e <strong>{front} </strong>a frente do
        </Text>
        <Flex alignItems="center" gap={1}>
          <Icon as={MdDoubleArrow} transform="rotate(90deg)" fontSize="20px" color="red.500" />
          <Box px={2} bgColor="red.500" color="white">
            {rankingValorProximo}º lugar
          </Box>
        </Flex>
      </Flex>
    </Flex>
  );
};
